import { render } from "./TenderSearchFilter.vue?vue&type=template&id=f3dd7040"
import script from "./TenderSearchFilter.vue?vue&type=script&lang=js"
export * from "./TenderSearchFilter.vue?vue&type=script&lang=js"
script.render = render

export default script